module.exports = __webpack_public_path__ + "static/four-steps-turorial-step-1-13a07064f59892fe9d1647107200a7b5.svg";